import { useState } from 'react';
export function useLightboxNavigation(images) {
  var [image, setImage] = useState(null);
  var currentIndex = image === null ? null : images.indexOf(image);
  var hasNext = typeof currentIndex === 'number' && images.length > 1;
  var hasPrevious = hasNext;
  function onClose() {
    setImage(null);
  }
  function onPrevious() {
    if (typeof currentIndex === 'number' && hasPrevious) {
      var previousIndex = (images.length + currentIndex - 1) % images.length;
      setImage(images[previousIndex]);
    }
  }
  function onNext() {
    if (typeof currentIndex === 'number' && hasNext) {
      var nextIndex = (currentIndex + 1) % images.length;
      setImage(images[nextIndex]);
    }
  }
  return {
    image,
    hasNext,
    hasPrevious,
    onOpen: setImage,
    onClose,
    onNext,
    onPrevious
  };
}